<template>
<div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
        <div class="well form-group" style="background: #e5e9ec">

            <!-- title -->
            <div class="grid-title no-border borderTop">
                <h4 style="padding-left: 6px"> {{ i18nValues["researchOrderEdition"] }} </h4>
            </div>    
            
            <!-- form -->
            <div class="grid-body no-border borderBottom">
                <el-form v-loading="loading != 0" :model="researchOrder" ref="formResearchOrder" :rules="rules">
                    <div class="gridTemplate">

                    <!-- DispatchType -->                
                    <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType">
                      <el-select v-model="researchOrder.dispatchType" :placeholder="i18nValues['dispatchType']" :disabled="this.researchOrder.status === 'printed'"
                      >
                        <el-option 
                          v-for="item in dispatchTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>   

                    <!-- Shipment -->    
                    <el-form-item :label="i18nValues['shipment']" prop="shipment"> 
                        <el-input v-model="researchOrder.shipment" maxlength="30" :disabled="this.researchOrder.status === 'printed'"></el-input>
                    </el-form-item>  

                    <!-- Date -->
                    <el-form-item :label="i18nValues['date']" prop="date">
                        <div class="input-group">
                        <el-date-picker :disabled="this.researchOrder.status === 'printed'"
                            type="date"
                            class="calendar"
                            format="dd/MM/yyyy"
                            v-model="researchOrder.date"
                            placeholder="Select date"
                        >
                        </el-date-picker>
                        <span class="input-group-addon primary el-input__suffix icon">
                            <span class="arrow"></span>
                            <i class="fa fa-calendar-alt"></i>
                        </span>
                        </div>
                    </el-form-item>
                        
                    <!-- Area -->    
                    <el-form-item :label="i18nValues['area']" prop="area"> 
                        <el-input v-model="researchOrder.area" :disabled="this.researchOrder.status === 'printed'"></el-input>
                     </el-form-item>  

                    <!-- Responsable -->    
                    <el-form-item :label="i18nValues['responsable']" prop="responsable"> 
                        <el-input v-model="researchOrder.responsable" :disabled="this.researchOrder.status === 'printed'"></el-input>
                     </el-form-item> 
    
                    <!-- Crop Type -->    
                    <el-form-item :label="i18nValues['crop']" prop="cropType">
                        <el-select  :disabled="this.researchOrder.status === 'printed'"
                        v-model="researchOrder.cropType"
                        :placeholder="i18nValues['crop']"
                        >
                        <el-option
                            v-for="item in variedades"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                        </el-select>
                    </el-form-item>

                    <!-- Description -->    
                    <el-form-item :label="i18nValues['description']" prop="description"> 
                        <el-input v-model="researchOrder.description" :disabled="this.researchOrder.status === 'printed'"></el-input>
                     </el-form-item> 

                    <!-- N Expediente -->    
                    <el-form-item :label="i18nValues['fileNumber']" prop="fileNumber"> 
                        <el-input v-model="researchOrder.fileNumber" :disabled="this.researchOrder.status === 'printed'"></el-input>
                     </el-form-item> 
                   
                    <!-- Event -->  
                    <el-form-item :label="i18nValues['event']" prop="event"> 
                        <el-select v-model="researchOrder.event" placeholder="Please select" value-key="id" filterable :disabled="this.researchOrder.status === 'printed'">
                            <el-option
                            v-for="item in EventsList"
                            :key="item.id"
                            :label="`${item.detailedTrait} ${item.name}`"
                            :value="item"                           
                            >
                            <span v-html="`<strong>${item.detailedTrait}</strong> - ${item.name}`"></span>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <!-- Subsidiary --> 
                    <el-form-item :label="i18nValues['supplier']" prop="supplier">   
                            <el-select v-model="researchOrder.supplier" placeholder="Please select" value-key="id" filterable :disabled="this.researchOrder.status === 'printed'">
                                    <el-option
                                        v-for="item in SuppliersList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item">
                                    </el-option>
                                </el-select>              
                    </el-form-item>

                    <!-- Customer --> 
                    <el-form-item :label="i18nValues['customer']" prop="customer">
                            <el-select v-model="researchOrder.customer" placeholder="Please select" value-key="id" filterable :disabled="this.researchOrder.status === 'printed'">
                                    <el-option
                                        v-for="item in CustomersList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item">
                                    </el-option>
                                </el-select>                   
                    </el-form-item>

                    <!-- Regulated Seed -->
                    <el-form-item :label="i18nValues['regulatedSeed']" prop="regulatedSeed" >
                      <el-checkbox
                        :disabled="this.researchOrder.status === 'printed'"
                        class="check3"
                        id="checkbox"
                        v-model="researchOrder.regulatedSeed"
                        v-on:change="$emit('change', true)"
                        @change="changeRules()"
                      >
                      </el-checkbox>
                    </el-form-item>
                
                    
                    </div> 
                    </el-form> 

                    <div></div>

                    <div>
                        <h6 v-if="this.researchOrder.status === 'edition'">Item De Investigacion</h6>
                    </div>

                    <el-form v-loading="loading != 0" :model="pallet" ref="formPallet" :rules="rulesPalletResearch">

                    <div class="gridTemplate" v-if="this.researchOrder.status === 'edition'">
                    <!-- Packaging -->    
                    <el-form-item prop="packaging"> 
                        <el-input v-model="pallet.packaging" :placeholder="i18nValues['packaging']"></el-input>
                    </el-form-item> 

                    <!-- Content of Packaging -->    
                    <el-form-item prop="bagsNumber"> 
                        <el-input v-model="pallet.bagsNumber" :placeholder="i18nValues['contentOfPackaging']" type="number"></el-input>
                    </el-form-item> 

                    <!-- ID Number -->    
                    <el-form-item prop="idNumber"> 
                        <el-input v-model="pallet.idNumber" :placeholder="i18nValues['idNumber']" type="number"></el-input>
                    </el-form-item> 

                    <!-- Net Weight -->    
                    <el-form-item prop="netWeight"> 
                        <el-input v-model="pallet.netWeight" :placeholder="i18nValues['netWeight']"
                        oninput="this.value = this.value.replace(/,/g, '')"></el-input>
                    </el-form-item> 
                
                    <!-- Gross Weight -->
                    <el-form-item prop="grossWeight"> 
                        <el-input v-model="pallet.grossWeight" :placeholder="i18nValues['grossWeight']"
                        oninput="this.value = this.value.replace(/,/g, '')"></el-input>
                    </el-form-item>

                    <!-- Lenght -->
                    <el-form-item prop="length"> 
                        <el-input v-model="pallet.length" :placeholder="i18nValues['length']" @keypress.native="isNumberWithDecimals($event)"></el-input>
                    </el-form-item>

                    <!-- Width -->
                    <el-form-item prop="width"> 
                        <el-input v-model="pallet.width" :placeholder="i18nValues['width']" @keypress.native="isNumberWithDecimals($event)"></el-input>
                    </el-form-item>

                    <!-- Height -->
                    <el-form-item prop="height"> 
                        <el-input v-model="pallet.height" :placeholder="i18nValues['height']" @keypress.native="isNumberWithDecimals($event)"></el-input>
                    </el-form-item>

                    <!-- Observations -->
                    <el-form-item prop="observation"> 
                        <!-- <el-input v-model="IandD.observation" type="textarea" :autosize="{minRows: 2}"></el-input> -->
                        <el-input v-model="pallet.observation" :placeholder="i18nValues['observations']"></el-input>
                    </el-form-item>
                        
                    <!-- Add Item-->
                    <div>
                    <el-button v-if="this.researchOrder.status === 'edition'"
                        @click="addPallet()"
                        icon="fas fa-plus"
                        id="searchButton"
                        size="small"
                        class="btn-primary"
                    >
                        {{ i18nValues["addItem"] }}
                    </el-button>
                    </div>
                </div>
                    <!-- table -->
                    <el-form-item prop="palletResearch">
                    <div class="full-width" style="margin:0 auto;padding:20px;">
                        <el-table
                        v-if="PalletsList.length > 0"
                        :data="PalletsList"
                        class="table table-hover table-striped"
                        id="palletsTable"
                        :empty-text="i18nValues['noDataAvailable']"
                        align="center"
                        >
                        <!-- Item Packaging -->
                        <el-table-column
                            prop="packaging"
                            :label="i18nValues['packaging']"
                            width="75"
                            align="center"
                        ></el-table-column>

                        <!-- Content Of Packaging -->
                        <el-table-column
                            prop="bagsNumber"
                            :label="i18nValues['contentOfPackaging']"
                            width="75"
                            align="right"
                        ></el-table-column>            
            
                        <!-- ID Number -->
                        <el-table-column
                            :label="i18nValues['idNumber']"
                            prop="idNumber"
                            width="75"
                            align="right"
                        ></el-table-column>           
            
                        <!-- Net Weight-->
                        <el-table-column
                            :label="i18nValues['netWeight']"
                            prop="netWeight"
                            width="75"
                            align="right"
                        ></el-table-column>  
            
                        <!-- Gross Weight -->
                        <el-table-column
                            :label="i18nValues['grossWeight']"
                            prop="grossWeight"
                            width="75"
                            align="right"
                        ></el-table-column>  

                        <!-- Lenght -->
                        <el-table-column
                            :label="i18nValues['length']"
                            prop="length"
                            width="75"
                            align="right"
                        ></el-table-column>  

                        <!-- Width -->
                        <el-table-column
                            :label="i18nValues['width']"
                            prop="width"
                            width="75"
                            align="right"
                        ></el-table-column>  

                        <!-- Height -->
                        <el-table-column
                            :label="i18nValues['height']"
                            prop="height"
                            width="75"
                            align="right"
                        ></el-table-column>  

                        <!-- Observations -->
                        <el-table-column
                            :label="i18nValues['observations']"
                            prop="observation"
                            width="90"
                            align="right"
                        ></el-table-column>  

                        <!-- ID -->
                        <el-table-column
                            :label="i18nValues['palletCode']"
                            :formatter = "formatPalletId"
                            width="75"
                            align="right"
                        ></el-table-column>  

                        <!-- REMOVE -->
                        <el-table-column width="90" align="right" v-if="this.researchOrder.status === 'edition'">
                            <template slot-scope="scope">
                            <el-button 
                                class="text-danger"
                                icon="fas fa-times"
                                size="small"
                                :title="i18nValues['remove']"
                                @click="removePallet(scope.row)"
                            ></el-button>
                            </template>
                        </el-table-column>
                        </el-table>
                    </div>
                    </el-form-item>
                </el-form> 

        <!-- CANCEL/PRINT/SAVE -->
        <div class="full-width d-flex justify-content-end mt-2">
          <el-button
            :loading="loading"
            size="small"
            @click="cancel()"
          >
            {{ i18nValues["cancel"] }}
          </el-button>
          <el-button v-if="!isReadOnly()"
            icon="fas fa-print"
            size="small"
            class="btn-primary"
            @click="print()"
          >
            {{ i18nValues["print"] }}
          </el-button>
          <el-button v-if="!isReadOnly() && this.researchOrder.status === 'edition'"
            icon="fas fa-check"
            :loading="loading"
            size="small"
            class="btn-primary"
            @click="save()"
          >
            {{ i18nValues["save"] }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
export default {
  name: "ResearchOrderEdition",

  created() {
    this.retrieveEvents();
    this.retrieveSuppliers();
    this.retrieveCustomers();

    if (this.id != 0) {
      this.retrieveById();
    } else {
      this.researchOrder.status = "edition";
      // this.researchOrder.creationUser = this.user.name;
      // this.researchOrder.creationDate = new Date();
    }

    this.rules = {
      dispatchType: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      shipment: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      supplier: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      customer: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      date: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      responsable: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      area: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      cropType: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      description: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      fileNumber: [
        {
          required: false,
          
        },
      ],
      event: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
    };

    this.rulesPalletResearch = {
      packaging: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      bagsNumber: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      idNumber: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      netWeight: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      grossWeight: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      length: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      width: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      height: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      observation: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
    };
  },

  components: {},

  computed: {
    loading: get("researchOrder/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
  },

  props: ["id"],

    data() {
        return {
            researchOrder:{
                event: null,
                customer: null,
                supplier: null,
            },
            pallet:{},

            item: {},

            rules: {},
            rulesPalletResearch:{},
            
            PalletsList: [],

            SuppliersList: [],
            EventsList: [],
            CustomersList: [],

            dispatchTypeOptions: [
              { value: "plane", label: "Aéreo" },
              { value: "ship", label: "Marítimo" },
            ],

            variedades: [
                { value: "corn", label: "Corn Seed" },
                { value: "soy", label: "Soybean Production" },
                { value: "soyRD", label: "Soybean R&D" },
            ],
        };
  },

  methods: {
    save() {
      this.$refs["formResearchOrder"].validate((valid) => {
        if (valid) {
          this.researchOrder.status = 'edition';
          this.researchOrder.pallets = this.PalletsList;
          if (this.globalCampaign) {
            this.researchOrder.campaign = this.globalCampaign;
          }
          if (this.globalFieldSite) {
            this.researchOrder.fieldSite = this.globalFieldSite;
          }
          this.researchOrder.pallets = this.PalletsList;
          this.$store
            .dispatch("researchOrder/saveResearchOrder", this.researchOrder)
            .then((res) => {
              if (res.status == "OK") {
                this.$notify.success({
                  title: this.i18nValues["succes"],
                  message: this.i18nValues["researchOrderSaved"],
                  position: "bottom-right",
                });
                this.$router.push({ name: "ResearchOrderAdmin" });
              } else {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["researchOrderSavedError"],
                  position: "bottom-right",
                });
              }
            });
        }
      });
    },

    cancel() {
      this.$router.push({ name: "ResearchOrderAdmin" });
    },

    retrieveById() {
      this.$store
        .dispatch("researchOrder/retrieveResearchOrderById", { id: this.id })
        .then((res) => {
          this.researchOrder = res;

          this.PalletsList = res.pallets;

          if (this.researchOrder.event == null) {
            this.researchOrder.event = {};
          }
          if (this.researchOrder.supplier == null) {
            this.researchOrder.supplier = {};
          }
          if (this.researchOrder.customer == null) {
            this.researchOrder.customer = {};
          }
        });
    },

    retrieveEvents() {
      this.$store.dispatch("event/retrieveEvents").then((res) => {
        this.EventsList = res;
      });
    },

    retrieveSuppliers() {
      this.$store.dispatch("supplier/retrieveSuppliers").then((res) => {
        this.SuppliersList = res;
      });
    },

    retrieveCustomers() {
      this.$store.dispatch("customer/retrieveCustomers").then((res) => {
        this.CustomersList = res;
      });
    },

    addPallet() {
      this.$refs["formPallet"].validate((valid) => {
          if(valid){
            this.pallet.creationDate = new Date();
            this.pallet.dispatchType = this.researchOrder.dispatchType;
            this.pallet.netWeight = Math.round(this.pallet.netWeight * 100) / 100;
            this.pallet.grossWeight = Math.round(this.pallet.grossWeight * 100) / 100;
            this.PalletsList.push(this.pallet);
            if (this.globalCampaign) {
              this.pallet.campaign = this.globalCampaign;
            }
            this.pallet = {};
          }
      });
    },

    removePallet(obj) {
      this.PalletsList = this.PalletsList.filter(
        (item) => item != obj
      );
    },

    print() {
      if(this.PalletsList == null || this.PalletsList == 0){
            this.$message({
              message: this.i18nValues["errorEmptyItems"],
              type: 'warning'
            });
            return;
        }
      this.$refs["formResearchOrder"].validate((valid) => {
        if (valid) {
          this.researchOrder.status = 'edition';
          this.researchOrder.pallets = this.PalletsList;
          if (this.globalCampaign) {
            this.researchOrder.campaign = this.globalCampaign;
          }
          if (this.globalFieldSite) {
            this.researchOrder.fieldSite = this.globalFieldSite;
          }
          this.$store
            .dispatch("researchOrder/saveResearchOrder", this.researchOrder)
            .then((res) => {
              if (res.status == "OK") {
                this.researchOrder.id  = res.values;
                this.$store
        .dispatch("researchOrder/downloadPDF", this.researchOrder.id)
        .then((res) => {
          if (res.size == 0) {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["errorDownload"],
              position: "bottom-right",
              duration: 7000,
            });
          } else {
            var blob = new Blob([res], { type: "application/pdf" });
            const links = document.createElement("a");
            links.href = URL.createObjectURL(blob);
            links.download = "I&D-" + this.researchOrder.shipment;
            links.click();
            URL.revokeObjectURL(links.href);
          }
          this.$router.push({ name: "ResearchOrderAdmin" });
        });
      this.$notify.success({
        title: this.i18nValues["succes"],
        message: this.i18nValues["printSuccess"],
        position: "bottom-right",
      });
                this.$notify.success({
                  title: this.i18nValues["succes"],
                  message: this.i18nValues["researchOrderSaved"],
                  position: "bottom-right",
                });
              } else {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["researchOrderSavedError"],
                  position: "bottom-right",
                });
              }
            });
        }
      })
      
      
    },

    formatPalletId(row) {
      if(row.status == 'loaded' || row.status == 'dispatched'){
        return row.id;
      }
    },

    changeRules(){
      if (this.researchOrder.regulatedSeed == false){
        this.rules.fileNumber = [
        {
          required: false,
        },
      ];
      } else {
        this.rules.fileNumber = [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ];
      }
    },

  },
};
</script>

<style></style>
